var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:['rph-social-link', `rph-social-link--${_vm.social}`],attrs:{"href":_vm.url,"type":_vm.social,"target":"_blank","rel":"noopener noreferrer","aria-label":_vm.social}},[_c(_vm.social,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }